// extracted by mini-css-extract-plugin
export default {"list":"paypal-giving-fund_list__bAjb4","button":"paypal-giving-fund_button__VYQIn"};